module.exports = __webpack_public_path__ + "static/media/background.673e372d.jpg";